import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import {
  Badge,
  Button,
  Dropdown,
  Modal,
  Nav,
  Tab,
  Table,
} from 'react-bootstrap';
import Editor from '@jsx/components/RichTextEditor';
import { AdminActions } from '@adapters/redux/reducer/admin';
import PageLoader from '../Loader/PageLoader';
import Swal from 'sweetalert2';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import { fullBackendPath } from 'core/helpers';
import { ICON_MORE } from '@services/constant';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const {
    galleries,
    updateData,
    uploadImageToAlbum,
    deleteImageFromAlbum,
    deleteData,
    updating,
  } = props;

  const [activeTab, setActiveTab] = useState(
    galleries?.[0]?.name?.toLowerCase()
  );

  const [showModal, setShowModal] = useState(false);

  const [modalType, setModalType] = useState('create');
  const [itemUpdate, setItemUpdate] = useState();

  const [name, setName] = useState('');
  const [nameVie, setNameVie] = useState('');

  useEffect(() => {
    if (!showModal) {
      setItemUpdate(null);
      setName('');
      setNameVie('');
    }
  }, [showModal]);

  const onClickShowModalCreate = () => {
    setModalType('create');
    setName('');
    setNameVie('');
    setShowModal(true);
  };

  const onClickShowModalEdit = (item) => {
    const { name, name_vi } = item;

    setModalType('edit');
    setItemUpdate(item);
    setName(name);
    setNameVie(name_vi);
    setShowModal(true);
  };

  const onSubmit = () => {
    const method = modalType === 'create' ? 'post' : 'put';
    const url = modalType === 'create' ? 'gallery' : `gallery/${itemUpdate.id}`;

    const params = {
      name,
      name_vi: nameVie,
    };

    updateData(method, url, params, 'galleries', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        setShowModal(false);
        notifySuccess(
          method === 'post' ? 'Create successfully' : 'Update successfully'
        );
        setActiveTab(params.name.toLowerCase());
      }
    });
  };

  const onClickDeleteAlbum = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, all images will be deleted and you will not be able to recover this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: 'red',
      position: 'top',
      customClass: 'margin-top-20',
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        deleteData(
          item.id,
          `gallery/${item.id}`,
          'galleries',
          (isError, error) => {
            if (isError) {
              notifyError(error);
            } else {
              notifySuccess('Delete successfully');
              setActiveTab(galleries?.[0]?.name?.toLowerCase());
            }
          }
        );
      }
    });
  };

  const onClickUploadImageToAlbum = (name, image) => {
    const params = { name, image };

    uploadImageToAlbum(params, (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        notifySuccess('Upload image successfully');
      }
    });
  };

  const onClickDeleteImage = (albumId, imageId) => {
    Swal.fire({
      title: '',
      text: 'Are you sure you want to delete this image?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: 'red',
      position: 'top',
      customClass: 'margin-top-20',
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        const params = { albumId, imageId };

        deleteImageFromAlbum(params, (isError, error) => {
          if (isError) {
            notifyError(error);
          } else {
            notifySuccess('Delete image successfully');
          }
        });
      }
    });
  };

  return (
    <Fragment>
      <div className="text-right mb-3">
        <button onClick={onClickShowModalCreate} className="btn btn-success">
          New Album
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">List Albums</h4>
            </div>
            <div className="card-body position-relative">
              {updating && !showModal && <PageLoader />}
              <Tab.Container activeKey={activeTab}>
                <Nav as="ul" className="nav-pills">
                  {galleries?.map((item, i) => (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link
                        eventKey={item.name.toLowerCase()}
                        onClick={() => setActiveTab(item.name.toLowerCase())}
                        className="album-tab-link"
                      >
                        <span
                          className="edit-album-button"
                          onClick={() => onClickShowModalEdit(item)}
                        >
                          <i className="fas fa-edit"></i>
                        </span>
                        {item.name}
                        <span
                          className="delete-album-button"
                          onClick={() => onClickDeleteAlbum(item)}
                        >
                          <i className="fas fa-trash"></i>
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
                <Tab.Content className="pt-4">
                  {galleries?.map((item, i) => (
                    <Tab.Pane eventKey={item.name.toLowerCase()} key={i}>
                      <div className="row">
                        <div className="col-xs-6 col-md-4 col-lg-3 square-div album-image-container">
                          <label
                            className="upload-image-button-container"
                            htmlFor={`upload-image-${i}`}
                          >
                            <i className="fas fa-plus" />
                          </label>
                          <input
                            type="file"
                            name={`upload-image-${i}`}
                            id={`upload-image-${i}`}
                            className="upload-image"
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              onClickUploadImageToAlbum(
                                item.name,
                                e.target.files[0]
                              )
                            }
                          />
                        </div>
                        {item.images?.map((image) => {
                          return (
                            <div
                              key={image.id}
                              className="col-xs-6 col-md-4 col-lg-3 square-div album-image-container"
                            >
                              <div className="image-container position-relative">
                                <img src={fullBackendPath(image.path)} />
                                <span
                                  className="delete-image-button"
                                  onClick={() =>
                                    onClickDeleteImage(item.id, image.id)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
      <Modal className="fade" enforceFocus={false} show={showModal} size="md">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <Modal.Header>
            <Modal.Title>
              {modalType === 'create' ? 'Create' : 'Edit'}
            </Modal.Title>
            <Button
              variant=""
              className="btn-close"
              onClick={() => setShowModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            {updating && <PageLoader />}
            <div className="form-group">
              <label className="form-label">Name (ENG)</label>
              <input
                className="form-control"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Name (VIE)</label>
              <input
                className="form-control"
                type="text"
                value={nameVie}
                onChange={(e) => setNameVie(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger light" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="" type="submit" className="btn btn-primary">
              {modalType === 'create' ? 'Create' : 'Update'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  galleries: state.admin.galleries,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
  uploadImageToAlbum: (params, callback) =>
    dispatch(AdminActions.uploadImageToAlbum(params, callback)),
  deleteImageFromAlbum: (params, callback) =>
    dispatch(AdminActions.deleteImageFromAlbum(params, callback)),
  deleteData: (id, url, field, callback) =>
    dispatch(AdminActions.deleteData(id, url, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
